import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Course from "./components/course/Course";
import Register from "./components/auth/Register";
import Login from "./components/auth/Login";
import ProfileEdit from "./components/auth/ProfileEdit";
import ResetPassword from "./components/auth/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import Homepage from "./components/Homepage";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions";
import FAQ from "./components/FAQ";
import ContactUs from "./components/ContactUs";
import { GlobalLoadingProvider } from "./contexts/GlobalLoadingContext";
import "./styles/global-loading.css";
function App() {

  return (
    <GlobalLoadingProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/profile-edit" element={<ProfileEdit />} />
          {/** Match the email link path so emails can point to frontend */}
          <Route path="/password/custom-reset" element={<ResetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/" element={<Homepage />} />            
          <Route path="/course/*" element={<ProtectedRoute />}>
            <Route path="home" element={<Course component="dashboardhome" />} />
            <Route path="page/:id" element={<Course component="page" />} />
            <Route path="security-question" element= {<Course component="securityquestion"/>}/>
            <Route path="scoreboard" element= {<Course component="scoreboard"/>}/>
            <Route path="course-result-card" element= {<Course component="courseresultcard"/>}/>
            <Route path="take-exam" element= {<Course component="exam"/>}/>
            <Route path="retake-checkout" element={<Course component="retake-checkout"/>}/>
          </Route>
        </Routes>
      </Router>
    </GlobalLoadingProvider>
  );
}

export default App;
